import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon-successfully-sent.',
  templateUrl: './icon-successfully_sent.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconSuccessfullySentComponent {}
